import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import Button from "@mui/material/Button";
import Avatar from "@mui/material/Avatar";
import { Box, Typography, Divider, Chip } from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";

import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import frLocale from "date-fns/locale/fr";
import EmailIcon from "@mui/icons-material/Email";
import PhoneIcon from "@mui/icons-material/Phone";
import HomeIcon from "@mui/icons-material/Home";
import BadgeIcon from "@mui/icons-material/Badge";
import ContactMailIcon from "@mui/icons-material/ContactMail";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import PersonPinIcon from "@mui/icons-material/PersonPin";
import { styled } from "@mui/material/styles";

import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { API } from "../../../api/API";
const StatusChip = styled(Chip)(({ theme, active }) => ({
  backgroundColor: active
    ? theme.palette.success.light
    : theme.palette.error.light,
  color: active ? theme.palette.success.dark : theme.palette.error.dark,
  fontWeight: 600,
}));

const InfoRow = ({ icon, label, value }) => (
  <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
    <Box sx={{ mr: 2, color: "text.secondary" }}>{icon}</Box>
    <Box>
      <Typography variant="caption" color="text.secondary">
        {label}
      </Typography>
      <Typography variant="body1">{value || "Non renseigné"}</Typography>
    </Box>
  </Box>
);

const ProfilPersonnelModal = ({ show, handleClose, personnel }) => {
  const [Personnel, setPersonnel] = useState(null);

  const getPersonnel = async () => {
    try {
      const res = await API.get(`assurance/agents/${id}`);
      const { data } = res.data;

      return data;
    } catch (error) {}
  };

  useEffect(() => {
    setPersonnel(personnel);
    getPersonnel();
  }, [personnel]);

  if (!Personnel) {
    return null;
  }
  const {
    id,
    nom,
    prenom,
    matricule,
    email,
    tel,
    role,

    adresse,
    date_naissance,
    statut,
    genre,
    created_by,
    createdAt,

    image,
    type_document_id,
    numero_document_id,
    date_delivre,
    lieu_delivre,
  } = Personnel;

  return (
    <Modal
      size="lg"
      show={show}
      onHide={handleClose}
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static"
    >
      <Modal.Header closeButton sx={{ borderBottom: "none", pb: 0 }}>
        <Typography variant="h5" component="h2" sx={{ fontWeight: 600 }}>
          Profil de {`${nom} ${prenom}`}
        </Typography>
      </Modal.Header>

      <Modal.Body>
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            gap: 4,
          }}
        >
          {/* Colonne de gauche - Photo et infos principales */}
          <Box
            sx={{
              width: { xs: "100%", md: "30%" },
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <Avatar
              src={image}
              sx={{
                width: 120,
                height: 120,
                mb: 3,
                fontSize: "3rem",
                bgcolor: "#37B049",
              }}
            >
              {nom?.charAt(0)}
              {prenom?.charAt(0)}
            </Avatar>

            <Typography
              variant="h6"
              sx={{ fontWeight: 600, textAlign: "center" }}
            >
              {nom} {prenom}
            </Typography>

            <StatusChip
              label={statut ? "Actif" : "Inactif"}
              active={statut}
              sx={{ mt: 1, mb: 2 }}
            />

            <Box sx={{ width: "100%", mt: 2 }}>
              <InfoRow
                icon={<BadgeIcon />}
                label="Matricule"
                value={matricule}
              />
              <InfoRow icon={<ContactMailIcon />} label="Role" value={role} />
              {genre && (
                <InfoRow icon={<PersonPinIcon />} label="Genre" value={genre} />
              )}
            </Box>
          </Box>

          {/* Colonne de droite - Détails */}
          <Box sx={{ width: { xs: "100%", md: "70%" } }}>
            <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 2 }}>
              Informations Personnelles
            </Typography>

            <Box sx={{ display: "flex", flexWrap: "wrap", gap: 2 }}>
              <Box sx={{ flex: 1, minWidth: 200 }}>
                <InfoRow icon={<EmailIcon />} label="Email" value={email} />
                <InfoRow icon={<PhoneIcon />} label="Téléphone" value={tel} />
                <InfoRow icon={<HomeIcon />} label="Adresse" value={adresse} />
              </Box>

              <Box sx={{ flex: 1, minWidth: 200 }}>
                {
                  <LocalizationProvider
                    dateAdapter={AdapterDayjs}
                    adapterLocale={frLocale}
                  >
                    <InfoRow
                      icon={<CalendarTodayIcon />}
                      label="Date de naissance"
                      value={
                        date_naissance && (
                          <DatePicker
                            value={dayjs(date_naissance)}
                            readOnly
                            disabled
                            slotProps={{
                              textField: {
                                variant: "standard",
                                fullWidth: true,
                                InputProps: { disableUnderline: true },
                              },
                            }}
                          />
                        )
                      }
                    />
                  </LocalizationProvider>
                }
              </Box>
            </Box>

            <Divider sx={{ my: 3 }} />

            <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 2 }}>
              Document d'Identification
            </Typography>

            <Box sx={{ display: "flex", flexWrap: "wrap", gap: 2 }}>
              <Box sx={{ flex: 1, minWidth: 200 }}>
                <InfoRow label="Type de document" value={type_document_id} />
                <InfoRow
                  label="Numéro de document"
                  value={numero_document_id}
                />
              </Box>

              <Box sx={{ flex: 1, minWidth: 200 }}>
                {
                  <LocalizationProvider
                    dateAdapter={AdapterDayjs}
                    adapterLocale={frLocale}
                  >
                    <InfoRow
                      label="Date de délivrance"
                      value={
                        date_delivre && (
                          <DatePicker
                            value={dayjs(date_delivre)}
                            readOnly
                            disabled
                            slotProps={{
                              textField: {
                                variant: "standard",
                                fullWidth: true,
                                InputProps: { disableUnderline: true },
                              },
                            }}
                          />
                        )
                      }
                    />
                  </LocalizationProvider>
                }
                <InfoRow label="Lieu de délivrance" value={lieu_delivre} />
              </Box>
            </Box>
          </Box>
        </Box>
      </Modal.Body>

      <Modal.Footer sx={{ borderTop: "none", pt: 0 }}>
        <Button
          variant="contained"
          onClick={handleClose}
          sx={{
            backgroundColor: "#37B049",
            "&:hover": { backgroundColor: "#2e8b3a" },
          }}
        >
          Fermer
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ProfilPersonnelModal;
